import React from 'react'
import OrdenoLoading, { OrdenoLoadingProps } from '../OrdenoLoading'

export type LoadingComponentProps = OrdenoLoadingProps

export const LoadingComponent: React.FC<LoadingComponentProps> = ({
  variant = 'fullscreen',
  withCard = true,
  size = 'md',
  text = 'Carregando...',
  ...rest
}) => {
  return (
    <OrdenoLoading
      variant={variant}
      withCard={withCard}
      size={size}
      text={text}
      {...rest}
    />
  )
}

export default LoadingComponent